import { ActivitiesApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { APPS_API_URL } = process.env;

export default new ActivitiesApi(APPS_API_URL, {}, olyEngineApi);
